import * as React from 'react';
import $ from 'jquery';
import Formatters from '../actions/Formatters';
import { PopupWindow } from '../components/sharedcomponents/PopupWindow';
var ProcessfirstCellOnlyRowIndex = -1;
var gridApiParams;
class ExportAction {
    static ExportSelectedRows(GridApiParams, formName) {
        gridApiParams = GridApiParams;
        //gridApiParams = [];
        //gridApiParams.push(gridApiParams);
        var IsGroupsExist = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getRowGroupColumns().length > 0 ? true : false;
        if (IsGroupsExist) {
            gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                {
                    columnGroups: false, //columnKeys: columnsToBeExported, 
                    onlySelected: true,
                    allColumns: true,
                    processGroupHeaderCallback: myGroupHeaderCallback, processHeaderCallback: myHeaderCallback,
                    processRowGroupCallback: myRowGroupCallback, processCellCallback: myCellCallback,
                    fileName: getFileName(formName),
                    sheetName: getFileName(formName)
                })
        }
        else {
            var allColumns = gridApiParams.gridOptionsWrapper.gridOptions.columnApi.getAllGridColumns();
            for (var i = allColumns.length - 1; i >= 0; i--) {
                if (allColumns[i].colDef.headerName === 'Group') {
                    allColumns.splice(i, 1);
                }
            }
            gridApiParams.gridOptionsWrapper.gridOptions.api.exportDataAsExcel(
                {
                    columnGroups: true,
                    columnKeys: allColumns,
                    skipGroups: true,
                    onlySelected: true,
                    processGroupHeaderCallback: myGroupHeaderCallback, processHeaderCallback: myHeaderCallback,
                    processRowGroupCallback: myRowGroupCallback, processCellCallback: myCellCallback,
                    fileName: getFileName(formName),
                    sheetName: getFileName(formName)
                })
        }
        setTimeout(() => {
            showMessageAndClosePopup(); 
        }, 1000);

    }


}
export default ExportAction;

function showMessageAndClosePopup() {
        $("#globalLoader").hide();
        PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
}
function getFileName(formName: string) {
    var currentDate = new Date();
    return formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds();
}
 function myGroupHeaderCallback(params) {

    var displayName = params.columnApi.getDisplayNameForColumnGroup(
        params.columnGroup
    );
    return displayName;
}

function myHeaderCallback(params) {
    var headerDisplayName = params.column.getColDef().headerName;
    switch (headerDisplayName) {
        case "Event Time": case "Reported Time": case "Created On": case "Last Modified On": case "Last Updated On": case "Updated On": case "Created Time": case "Modified Time":
        case 'StatusDate': case 'Submitted Dt': case 'Expiration Dt': case 'Status Time': case 'Submitted Time': case 'Expiration Time': case "Door time":
        case "Event time": case "Receipt time"://RCNG-1143
            return Formatters.TimeZoneFormatter(headerDisplayName);
        case "Device temp. ": case "Device temp "://RCNG-1143
            return Formatters.TemperatureHeaderFormatter(headerDisplayName);
        default:
            return headerDisplayName;
    }
}
function myRowGroupCallback(params) {

    var indent = '--';
    var node = params.node;
    //var label = node.key.toUpperCase();

    var label = getGroupDisplayValueName(params);
    if (!node.parent.parent) {
        return label; // top level node, parent is root node
    }
    label = '> ' + label;
    // indent once per level in the row group hierarchy
    while (node.parent.parent) {
        label = indent + label;
        node = node.parent;
    }
    return label;

} 

function getGroupDisplayValueName(params) {
    if (params != undefined && params != null) {

        var fieldName = params.node.field;
        var fieldValue = params.node.key;

        var colDef = params.node.columnApi.columnController.rowGroupColumns.filter(x => x.colId == fieldName);
        var columnDisplayName = colDef[0].colDef.headerName;

        if (fieldValue.toString().trim() == "-999" && (fieldName === 'BatteryVoltage' || fieldName === 'DoorSensorBatteryVoltage'))
            return "*No " + columnDisplayName;

        if (fieldValue == "-NA-" || fieldValue == "null")
            return "*No " + columnDisplayName;

        if (fieldValue.toString().trim() == "-999")
            return "OOR";

        switch (fieldName) {
            case "IgnitionOn":
                return Formatters.GensetSwitchFormatterGroupingExcel(fieldValue);
            case "GensetRunning":
                return Formatters.EngineSortingFormatterGroupingExcel(fieldValue);
            case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case "DLEventDTTM": case 'DoorEventDtm':
                return Formatters.dateTypeFormatterGrouping(fieldValue);

            case 'DeviceTemp':
                {
                    return Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                }
            case 'IsInsideGeofence': case 'IsActive':
                {
                    return Formatters.YesNoConverterforExcel(fieldValue);
                }

            case "DevicePowerSourceCd":
                return Formatters.PowerStateFormatterGroupingForExcel(fieldValue);//done

            case 'BatteryVoltage':
                {
                    return (fieldValue == "" || fieldValue == null || fieldValue === '-NA-' || fieldValue === '-999') ? '-NA-' : Formatters.BattVoltageSortingGrouping(fieldValue);
                }
            case 'DeviceConfig': case 'GuestReeferMode':
                {

                    return Formatters.GuestReeferModeFormatterForExcel(fieldValue);
                }

            case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) return Formatters.rcdPowerSourceFormatterforExcel(fieldValue);

            case "CustomerName":
                {
                    if (columnDisplayName == 'Assigned To')
                        return fieldValue == JSON.parse(sessionStorage.getItem('customerDetails')).CustomerName ? "-NA-" : fieldValue;
                    else
                        return fieldValue;
                }
            case "ReeferOEMTypeCd":
                return Formatters.OEMTypeFormatterGrouping(fieldValue);
            case "RSSI":
                return Formatters.RSSIFormatterGroupingForExcel(fieldValue);
            case "DeviceConfig":
                return Formatters.GuestReeferModeGrouping(fieldValue);

            case "AssetType":
                return Formatters.AssetTypeGrouping(fieldValue);
            case "GeofenceCategoryCd":
                return Formatters.GeofenceTypeGrouping(fieldValue);
            case "FilerepositoryActionCD":
                return Formatters.FileStatusGrouping(fieldValue);
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterForExcel(fieldValue, params);
             case "DoorOpen":
                return Formatters.DeviceDoorFormatterGrouping(fieldValue);
            default:
                return fieldValue;

        }

    }
}
function myCellCallback(params) {
    var returnValue;

    if (params.node.group && ProcessfirstCellOnlyRowIndex != params.node.rowGroupIndex) {
        ProcessfirstCellOnlyRowIndex = params.node.rowGroupIndex
        if (params.node.key != null && params.node.key != undefined)
            return myRowGroupCallback(params);
    }

    if (params.node.group && params.column.colId === "0") {
        return myRowGroupCallback(params);
    }

    if (!params.node.group) {
        switch (params.column.colId) {

            case 'RCDID': case 'RCDId': case 'TowerBaseStationID': case 'ICCID': case 'MSISDN': case 'SIM_IMSI': case 'RcdID':
                {
                    if (params.value == undefined || params.value == "-NA-")
                        returnValue = "-NA-";
                    else
                        returnValue = params.value;
                }
                break;
            case 'Name': case 'Tag': case 'Address':
                {
                    if (params.value != undefined && params.value != null)
                        returnValue = Formatters.stringTypeFormatterChildFormsNew(params.value);
                    else
                        returnValue = "-NA-";
                }
                break;
            case 'Coordinates':
                if (params.value != undefined && params.value != null)
                    returnValue = Formatters.GeofenceCoordinatesFormatterforExcel(params.value);
                else
                    returnValue = "-NA-";
                break;
            case 'DeviceTemp':
                {
                    if (params != undefined && params != null)
                        returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                    else
                        returnValue = "-NA-";
                }
                break
            case 'UnitEventDTTM': case 'DataLoggerDtm': case 'ModifiedDTTM': case 'EventDTTM': case 'R_EventDTTM': case 'R_ModifiedDTTM': case 'CreatedDTTM': case 'CreateDTTM': case 'StatusDate': case 'SubmittedOn': case 'TTL': case 'ExpirationTime': case 'PTRDateTime': case "DLEventDTTM": case 'DoorEventDtm':
                {
                    //if (params.value != undefined && params.value != null)
                    returnValue = Formatters.dateTypeFormatterforExcel(params.value);
                }
                break

            case 'IsInsideGeofence': case 'IsActive': case 'HasFuelSensor': case 'HasOilPressureSwitch': case 'HasDoorSensor': case 'IsDeployed':
                {
                    //if (params.value != undefined && params.value != null)
                        returnValue = Formatters.YesNoConverterforExcel(params.value);
                }
                break
            case 'ReeferOEMTypeCd': case 'ÓEMTypeCD':
                {
                    //if (params.value != undefined && params.value != null)
                    returnValue = Formatters.GetOEMTypeDescription(params.value);
                }
                break;

            case 'BatteryVoltage': case 'DoorSensorBatteryVoltage':
                {
                    if (params.value != undefined && params.value != null)
                        returnValue = Formatters.BattVoltageFormatterforExcel(params.value);
                }
                break;
            case 'DeviceConfig': case 'GuestReeferMode':
                {
                    if (params.value != undefined && params.value != null)
                        returnValue = Formatters.GuestReeferModeFormatterForExcel(params.value);
                }
                break;

            case 'RCDPOWERSOURCECD': if (params.value != undefined && params.value != null) returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value);
                break;


            case 'GPSLastLock': if (params.value != undefined && params.value != null) returnValue = Formatters.secondsToTimeConverterForExcel(params.node.data.GPSLastLock); break;

            case 'IgnitionOn': if (params.value != undefined && params.value != null) returnValue = Formatters.gensetSwitchFormatterForExcel(params.value); break;

            case 'CustomerName':
                {
                    if (params.column.colDef.headerName == 'Assigned To')
                        returnValue = Formatters.stringTypeFormatterFor3PExcel(params.value);
                    else
                        returnValue = params.value;
                }
                break;

            case "RSSI": if (params.value != undefined && params.value != null) returnValue = params.node.data.RSSI; break;

            case "GetFileRepositoryActionDesc": returnValue = Formatters.GetFileRepositoryActionDesc(params.value); break;

            case "RunState": returnValue = Formatters.runStateFormatterforExcel(params.node.data.RunState.toUpperCase().trim()); break;

            case "RcdPowerSourceCd": returnValue = Formatters.rcdPowerSourceFormatterforExcel(params.value); break;

            case 'ManufacturedDate':
                {
                    returnValue = Formatters.YearFromdateTypeFormatterForExcel(params.value);
                }
                break;
            case 'AssetType': returnValue = Formatters.AssetTypeFormatterForExcel(params.value);
                break;
            case 'DoorOpen':
                {
                    if (params.value != undefined && params.value != null) {
                        returnValue = Formatters.DeviceDoorFormatterExcel(params.value);
                    }
                }
                break;
            case 'GeofenceCategoryCd': if (params.value != undefined && params.value != null) returnValue = Formatters.fenceTypeFormatterForExcel(params.value);
                break;
            case 'GensetRunning': {
                if (params.value != undefined && params.value != null) {
                    var HasOilPressureSwitch;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        HasOilPressureSwitch = gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].HasOilPressureSwitch;
                    }
                    else {
                        HasOilPressureSwitch = false;
                    }

                    //if (HasOilPressureSwitch != undefined && HasOilPressureSwitch != null)
                    var isGensetRunning = {
                        GensetRunning: params.node.data.GensetRunning,
                        HasOilPressureSwitch: params.node.data.HasOilPressureSwitch,
                        OEMTypeCD: params.node.data.OEMTypeCD
                    };
                    returnValue = Formatters.EngFormatterforExcel(isGensetRunning);
                }
            }
                break;

            case 'DevicePowerSourceCd': {
                if (params.value != undefined && params.value != null) {
                    var DeviceConfig;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceConfig = gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceConfig;
                    }
                    else {
                        DeviceConfig = false;
                    }

                    var DeviceType;
                    if (params.node.rowIndex != undefined && params.node.rowIndex != null
                        && gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != undefined
                        && gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex] != null) {
                        DeviceType = gridApiParams.rowRenderer.gridOptionsWrapper.gridOptions.rowData[params.node.rowIndex].DeviceType;
                    }
                    else {
                        DeviceType = "";
                    }

                    var ispwrStateFormatter = {
                        DeviceType: params.node.data.DeviceConfig,
                        DevicePowerSourceCd: params.node.data.DevicePowerSourceCd,
                        DeviceTypeCd: params.node.data.DeviceType
                    }
                    
                    //if (DeviceType != undefined && DeviceType != null && DeviceConfig != undefined && DeviceConfig != null)
                    returnValue = Formatters.pwrStateFormatterforExcel(ispwrStateFormatter);
                }
            }
                break;
            case 'CO2Setpoint': case 'CO2Reading': case 'O2Setpoint': case 'O2Reading': case 'EvaporatorTemp':
            case 'CompositeSuctionPressure': case 'CompressorSuctionTemp': case 'DischargePressure': case 'CompressorDischargeTemp':
            case 'CondenserTemperature': case 'CondenserFanOutPut': case 'LowSpeedEvaporatorFanOutPut': case 'HighSpeedEvaporatorFanOutPut':
            case 'HeaterOnTime': case 'HotGasValveOpening': case 'EconomizerValveOpening': case 'CompressorFrequency': case 'VentPositionSensorCMH':
            case 'TotalCurrentDraw': case 'LineVoltage1': case 'LineVoltage2': case 'LineVoltage3': case 'VFD': case 'LineFrequency':
                {
                    if (params.value != undefined && params.value != null)
                        returnValue = Formatters.sensorDataFormatterforExcel(params.value);
                    else
                        returnValue = "-NA-";
                }
                break;
            case 'TemperatureUnit': case 'SetPoint': case 'SupplyTemp1': case 'SupplyTemp2': case 'ReturnTemp1': case 'ReturnTemp2':
            case 'AmbientTemp': case 'EvaporatorTemp': case 'CompressorSuctionTemp': case 'CompressorDischargeTemp':
            case 'CondenserTemperature': case 'USDA1Temp': case 'USDA2Temp': case 'USDA3Temp': case 'Cargo4Temp': case 'SensorSupplyTemp1': case 'SensorReturnTemp1':
                {
                    if (params.value != undefined && params.value != null)
                        returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params.value);
                    else
                        returnValue = "-NA-";
                }
                break
            case 'DeviceTemp': 
                {
                    if (params != undefined && params != null)
                        returnValue = Formatters.TemperatureFormatterExcelForDeviceTemp(params);
                    else
                        returnValue = "-NA-";
                }
                break
            case 'CCSeverityLevel':
                {
                    if (params.value != undefined && params.value != null) {

                        var IsCargoCare = {
                            isCargocare: params.node.data.IsCargoCare,
                            CCSeverityLevel: params.node.data.CCSeverityLevel
                        };
                        returnValue = Formatters.CargoCareFormatterforExcel(IsCargoCare);
                    }
                    else
                        return "-NA-";
                }
                break;
            case 'MASeverityLevel':
                {
                    returnValue = Formatters.statusIndicatorforALMforExcel(params.node.data.MASeverityLevel);
                }
                break;
            case 'AlarmsList': returnValue = Formatters.AlarmListFormatterforExcel(params.value); break;
            case 'Humidity':
                {
                    var isHumidity = {
                        Humidity: params.node.data.Humidity,
                        HumiditySetpointStatus: params.node.data.HumiditySetpointStatus
                    };
                    returnValue = Formatters.HumiditySettingFormatterforExcel(isHumidity);
                }
                break;
            case 'CondenserPressure':
                {
                    var CondenserPressureData = {
                        ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                        CondenserPressure: params.node.data.CondenserPressure
                    };
                    returnValue = Formatters.sensorDataPCondFormatterExcel(CondenserPressureData);
                }
                break;
            case 'EvaporatorExpansionValveOpening':
                {
                    var EEVData = {
                        ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                        EvaporatorExpansionValveOpening: params.node.data.EvaporatorExpansionValveOpening
                    };
                    returnValue = Formatters.sensorDataOpenExpFormatterExcel(EEVData);
                }
                break;
            case 'SuctionModulationValveOpening':
                {
                    var SuctionModulationValveOpeningData = {
                        ReeferOEMTypeCd: params.node.data.ReeferOEMTypeCd,
                        SuctionModulationValveOpeningQualifier: params.node.data.SuctionModulationValveOpeningQualifier,
                        SuctionModulationValveOpening: params.node.data.SuctionModulationValveOpening
                    };
                    returnValue = Formatters.sensorDataOpenSucFormatterForExcel(SuctionModulationValveOpeningData);
                }
                break;
            case "ThreePhaseCurrent": returnValue = Formatters.Current3PhaseFormatterforExcel(params.value); break;
            case "FilerepositoryActionCD":
                {
                    if (params.value != null && params.value != undefined && params.value != '' && params.value != "null")
                        returnValue = Formatters.GetFileRepositoryActionDesc(params.node.data.FilerepositoryActionCD);
                    else
                        return "-NA-";
                }
                break;
            case "GPSCoords":
                return Formatters.GPSCoordsFormatterGroupingForExcel(params);
            case 'HumiditySetpoint':
                {
                    if (params.value != null && params.value != undefined && params.value != '' && params.value != "null")
                        returnValue = Formatters.HumiditySetpointForExcel(params.value, params.node.data.HumiditySetpointStatus);
                    else
                        return "-NA-";
                }
                break; 
            default: {
                if (params.value != null && params.value != undefined && params.value != '' && params.value != "null") {
                    returnValue = params.value;
                }
                else if (params.column.colId === "0") {
                    return "";
                }
                else
                    returnValue = "-NA-";
            }
        }

        return returnValue;
    }
}
